<div class="modal-header justify-content-between align-items-center">
    <div class="text-primary t-20 t-sb">{{ 'setting.notifications.modalTitle' | translate }}</div>
    <button [hoverEffect]="false" (click)="close()" appButtonIcon data-test="notification-button__close">
        <svg-icon [src]="svgDefaultSrc + 'Close.svg'" svgClass="close"></svg-icon>
    </button>
</div>
<form *ngIf="notificationSettingsForm" [formGroup]="notificationSettingsForm">
    <div class="modal-body">
        <div class="mb-4">
            <div class="t-18 mb-2">{{ 'setting.notifications.contactDetails' | translate }}</div>
            <div class="row">
                <div class="col-3 t-b">{{ 'setting.notifications.email' | translate }}:</div>
                <div class="col" data-test="content-mail">{{ userEmail }}</div>
            </div>
            <div class="row">
                <div class="col-3 t-b">{{ 'setting.notifications.phone' | translate }}:</div>
                <div class="col" data-test="content-phone">{{ userPhone }}</div>
            </div>
        </div>
        <div>
            <div class="row">
                <div class="offset-6 col text-center">{{ 'setting.notifications.options.email' | translate }}</div>
                <div class="col text-center">{{ 'setting.notifications.options.sms' | translate }}</div>
            </div>
            <div class="row mb-3 mt-1 align-items-center">
                <div class="col-6 t-18">{{ 'setting.notifications.notificationAbout' | translate }}</div>
                <div class="col text-center">
                    <div class="form-switch">
                        <input
                            id="emailSelectAll"
                            class="form-check-input"
                            [ngbTooltip]="'setting.notifications.selectOrDeselectAll' | translate"
                            type="checkbox"
                            role="switch"
                            data-test="notification-all__mail"
                            formControlName="areAllEmailNotificationsSelected"
                            placement="left" />
                    </div>
                </div>
                <div class="col text-center">
                    <div class="form-switch">
                        <input
                            id="smsSelectAll"
                            class="form-check-input"
                            [ngbTooltip]="'setting.notifications.selectOrDeselectAll' | translate"
                            type="checkbox"
                            role="switch"
                            data-test="notification-all__sms"
                            formControlName="areAllSmsNotificationsSelected"
                            placement="left" />
                    </div>
                </div>
            </div>
            <ng-container formArrayName="notificationSettings">
                <ng-container
                    *ngFor="let setting of notificationSettingsFormArray.controls; let i = index"
                    [formGroupName]="i">
                    <div class="row my-2" data-test="notification-code">
                        <div class="col-6">
                            {{ 'enums.notificationCode.' + setting.get('operation')?.value | translate }}
                        </div>
                        <div class="col text-center">
                            <div class="form-switch">
                                <input
                                    id="email"
                                    class="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    data-test="notification-code__email"
                                    formControlName="mail" />
                            </div>
                        </div>
                        <div class="col text-center">
                            <div class="form-switch">
                                <input
                                    id="sms"
                                    class="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    data-test="notification-code__sms"
                                    formControlName="sms" />
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </div>
    <div class="modal-footer">
        <button [hoverEffect]="false" (click)="close()" data-test="notification-button__close" appButtonStroked>
            {{ 'buttons.cancel' | translate }}
        </button>
        <button
            class="ms-2"
            [disabled]="!notificationSettingsForm.dirty"
            (click)="save()"
            appButtonFlat
            data-test="notification-button__save">
            {{ 'buttons.save' | translate }}
        </button>
    </div>
</form>
